export const REGISTER_URL = "https://business.stippl.io/register";
export const DEMO_URL = "https://calendar.app.google/KNMuNDYdgFijgGdB8";
